function path(root: string, sublink: string) {
  return `${root}/${sublink}`.replace('///', '/').replace('//', '/');
}

const ROOT = '/';
const ROOT_PATH = path(ROOT, '');

export const PATH_AUTH = {
  login: path(ROOT_PATH, 'login'),
  findId: {
    root: path(ROOT_PATH, 'find-id'),
    end: path(ROOT_PATH, 'find-id/end'),
  },
  resetPwd: {
    root: path(ROOT_PATH, 'reset-pwd'),
    form: path(ROOT_PATH, 'reset-pwd/form'),
    end: path(ROOT_PATH, 'reset-pwd/end'),
  },
  register: {
    root: path(ROOT_PATH, 'register'),
    end: path(ROOT_PATH, 'register/end'),
  },
  profileCompletion: path(ROOT_PATH, 'profile-completion'),
};

export const PATH_PAGE = {
  home: path(ROOT_PATH, '/'),
  page403: path(ROOT_PATH, '403'),
  page404: path(ROOT_PATH, '404'),
  page500: path(ROOT_PATH, '500'),

  // 보존 (GLP-1에서도 사용)
  medicalQuestion: {
    root: path(ROOT_PATH, 'medical-question'),
    form: path(ROOT_PATH, 'medical-question/form'),
    end: path(ROOT_PATH, 'medical-question/end'),
  },
  drugQuestion: {
    root: path(ROOT_PATH, 'drug-question'),
    form: path(ROOT_PATH, 'drug-question/form'),
  },
  medicineSettings: {
    root: path(ROOT_PATH, 'medicine-settings'),
  },
  calendar: {
    root: path(ROOT_PATH, 'calendar'),
  },
  record: {
    root: path(ROOT_PATH, 'record'),
  },
  report: {
    root: path(ROOT_PATH, 'report'),
  },
  care: {
    root: path(ROOT_PATH, 'care'),
  },
  myPage: {
    root: path(ROOT_PATH, 'my-page'),
    pharmacy: path(ROOT_PATH, 'my-page/pharmacy'),
    medicineInfo: path(ROOT_PATH, 'my-page/medicine-info'),
    privacy: path(ROOT_PATH, 'my-page/privacy'),
    customerService: {
      root: path(ROOT_PATH, 'my-page/customer-service'),
      faq: path(ROOT_PATH, 'my-page/customer-service/faq'),
      notice: path(ROOT_PATH, 'my-page/customer-service/notice'),
      inquiry: path(ROOT_PATH, 'my-page/customer-service/inquiry'),
      inquiryNew: path(ROOT_PATH, 'my-page/customer-service/inquiry/new'),
    },
    appInfo: path(ROOT_PATH, 'my-page/app-info'),
    openSourceLicense: path(ROOT_PATH, 'my-page/app-info/license'),
    edit: {
      profile: path(ROOT_PATH, 'my-page/edit-profile'),
      memberInfo: path(ROOT_PATH, 'my-page/edit-member-info'),
    },
    settings: {
      terms: path(ROOT_PATH, 'my-page/terms-settings'),
      termsDetail: path(ROOT_PATH, 'my-page/terms-settings/detail'),
      notification: path(ROOT_PATH, 'my-page/notification-settings'),
      language: path(ROOT_PATH, 'my-page/language-settings'),
      persona: path(ROOT_PATH, 'my-page/persona-settings'),
    },
    withdrawal: path(ROOT_PATH, 'withdrawal'),
  },
  policy: path(ROOT_PATH, 'policy'),
  notification: path(ROOT_PATH, 'notification'),

  // GLP-1 신규 (W2~W4에서 화면 구현)
  // record: { root: path(ROOT_PATH, 'record') },           // 식사/체중/증상 기록
  // report: { root: path(ROOT_PATH, 'report') },           // 주간/종합 리포트
  // care:   { root: path(ROOT_PATH, 'care') },             // 운동/식단/부작용 가이드
  // chat:   { root: path(ROOT_PATH, 'chat') },             // 챗봇 풀스크린
};
